import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../footer";
import RegisterVisual from "../Visual/registerVisual";
import { SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";

let serverUrl = window.location.origin;

type FormInputs = {
    file: FileList,
};

function Register() {

    const navigate = useNavigate();
    const notifyError = (err:any) => toast.error(err,{theme:"colored"});
    const notifySuccess = (text:any) => toast.success(text,{theme:"colored"});

    const [visualTitle, setVisualTitle] = useState("Organisation Registration");
    const {register, handleSubmit, setError, formState: {errors}} = useForm<FormInputs>();

    const [brandData, setBrandData] = useState({
        name: "",
        website_url : "",
        summary :"",
        location:"",
        location_iso:"",
        business_registry_info :"",
        eori:"",
        logo:"",
        new: true,
    });
  
    const changeBrandData = (name: string, data: any): void => {
        if(name == 'location'){
            setBrandData({ ...brandData, [name]: data.toUpperCase() });
        }else{
            setBrandData({ ...brandData, [name]: data });
        }
    };
  

    const onSubmitForm: SubmitHandler<FormInputs> = (data: FormInputs) => { 
        let apiValues = {
            name: brandData.name,
            website_url: brandData.website_url ,
            summary:brandData.summary,
            location:brandData.location,
            location_iso:brandData.location_iso,
            eori:brandData.eori,
            logo:brandData.logo,
            business_registry_info :brandData.business_registry_info , //Organisation website
        }

        var url = serverUrl + "/api/v1/owners" ;

        fetch(url,{
            method:"POST",
            headers: {
                accept: 'application.json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(apiValues)
        })
        .then(async response => {
    
            // check for error response
            if (!response.ok ) {
                // get error message from body or default to response status
                console.log("Error in response code")
                const error = await response.text();
                return Promise.reject(error);

            }else{
    
                const data1 = await response.text();
                const data = JSON.parse(data1);
                //console.log(data);
                
                notifySuccess("Onboarding process completed.");
                window.location.href = "/registerManufacturer";
            } 
        })
        .catch(error => {
            console.error("Error in API Issue: ", error);
            notifyError("Error in onboarding API: " + error);
        }); 
    }    

    return (<>
    
        <div className="company">

            <RegisterVisual title={visualTitle}/>

            <div className="explorer">

                <form className="form" onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        handleSubmit(onSubmitForm)(event);
                    }} >

                    <div>
                        <label> <span className="requiredMark">*</span> Product Owner's Name{" "} </label>
                        <input type="text" className="issuer-form" name="name" maxLength={400} placeholder="e.g., John Doe" value={brandData.name} onChange={(event) => { changeBrandData("name", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Website{" "} </label>
                        <input type="url" className="issuer-form" name="website_url" maxLength={1000} placeholder="e.g., https://www.example.com/" value={brandData.website_url } onChange={(event) => { changeBrandData("website_url", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Company Description{" "} </label>
                        <input type="text" className="issuer-form" name="summary" maxLength={1000} placeholder="e.g., We are a technology company specializing in software development and digital products." value={brandData.summary } onChange={(event) => { changeBrandData("summary", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Location{" "} </label>
                        <input type="text" className="issuer-form" name="location" maxLength={2} placeholder="e.g., US" value={brandData.location } onChange={(event) => { changeBrandData("location", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> Location ISO{" "} </label>
                        <input type="text" className="issuer-form" name="location_iso" maxLength={1000} placeholder="e.g., urn:iso:std:iso:3166:-2:US" value={brandData.location_iso } onChange={(event) => { changeBrandData("location_iso", event.target.value); }} ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Business Registry Link{" "} </label>
                        <input type="url" className="issuer-form" name="business_registry_info" maxLength={1000} placeholder="e.g., https://www.example-registry.com" value={brandData.business_registry_info } onChange={(event) => { changeBrandData("business_registry_info", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> Economic Operators Registration and Identification Number (EORI){" "} </label>
                        <input type="text" className="issuer-form" name="eori" maxLength={1000} placeholder="e.g., 1234567890" value={brandData.eori } onChange={(event) => { changeBrandData("eori", event.target.value); }} ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Logo{" "} </label>
                        <input type="url" className="issuer-form" name="logo" maxLength={1000} placeholder="e.g., https://www.example.com/logo.png" value={brandData.logo } onChange={(event) => { changeBrandData("logo", event.target.value); }} required></input>
                    </div>

                    <button  className="btn btn-primary" type="submit"> Register </button>
                </form>

            </div>
      
            <Footer/>
        </div>
    </>);
}

export default Register;
